
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import { RCard, RButton, RInput } from '@/components'
import { isAlreadyPending } from '@/store/root'

type ReedemCodeInputData = {
  codeToRedeem: string
}

export default Vue.extend({
  components: {
    RCard,
    RButton,
    RInput,
  },
  props: {
    hasPaymentMethod: {
      type: Boolean,
    },
  },
  data(): ReedemCodeInputData {
    return {
      codeToRedeem: '',
    }
  },
  methods: {
    async handleRedeem() {
      const { codeToRedeem } = this
      if (!codeToRedeem) return
      await this.redeemCode(codeToRedeem)
      this.codeToRedeem = ''
    },
    ...mapActions({
      redeemCode: 'payment/redeemCode',
    }),
  },
  computed: {
    redeemCodeRequestPending(): boolean {
      return isAlreadyPending(this.redeemCodeRequest)
    },
    redeemCodeButtonDisabled(): boolean {
      return !this.codeToRedeem || this.redeemCodeRequestPending
    },
    ...mapGetters({
      redeemCodeRequest: 'payment/redeemCodeRequest',
    }),
  },
})
